// extracted by css-extract-rspack-plugin
export default {"root":"root-epiBLy","compact":"compact-kdt2vj"};